import { render } from "./IconNoteAdd.vue?vue&type=template&id=effa47b8"
import script from "./IconNoteAdd.vue?vue&type=script&lang=js"
export * from "./IconNoteAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__